import './App.css';

function App() {
  return (
    <div className="App">
      <div>
        <h1>Privacy Policy</h1>
        <p>
          <strong>Effective Date:</strong> 08/22/2024
        </p>

        <h2>1. Introduction</h2>
        <p>
          Thank you for using our QuickSet Timer. This Privacy Policy outlines how
          we handle your information. We value your privacy and are committed to
          being transparent about our practices.
        </p>

        <h2>2. Information We Do Not Collect</h2>
        <p>
          We do not collect any personal information or data from users of the
          App. The App operates without requiring any form of user data, and no
          data is stored, transmitted, or shared.
        </p>

        <h2>3. No Third-Party Services</h2>
        <p>
          Our App does not use any third-party services that may collect
          information used to identify you.
        </p>

        <h2>4. Children's Privacy</h2>
        <p>
          Since the App does not collect any personal information, it is safe for
          users of all ages, including children under the age of 13.
        </p>

        <h2>5. Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy from time to time. Any changes will be
          reflected on this page, and we encourage you to review this Privacy
          Policy periodically.
        </p>

        <h2>6. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please
          contact us at{" "}
          <a href="mailto:sanzay8342258@gmail.com">[sanzay8342258@gmail.com]</a>.
        </p>
      </div>
    </div>
  );
}

export default App;
